import React from "react";
import { Mail, Phone, Globe } from "lucide-react";
import { useLang } from "../../contexts/LanguageContext";

const LOGO_URL =
  "https://jaytech.id/images/logo.png";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0B1120] text-slate-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-sm bg-[#FFFFFF] ring-1 ring-white/10 overflow-hidden">
                <img src={LOGO_URL} alt="Jaytech" className="h-11 w-11 object-cover" />
              </span>
              <div className="leading-none">
                <div className="font-heading font-extrabold text-white text-base tracking-tight">JAYTECH</div>
                <div className="text-[10px] tracking-[0.22em] text-slate-500 uppercase mt-1">
                  Informatika Indonesia
                </div>
              </div>
            </div>
            <p className="mt-6 text-sm text-slate-400 leading-relaxed max-w-sm">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.24em] uppercase font-bold text-slate-500">
              {t.footer.sections.company}
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#about" className="hover:text-white transition-colors">{t.footer.links.about}</a></li>
              <li><a href="#why" className="hover:text-white transition-colors">{t.footer.links.why}</a></li>
              <li><a href="#industries" className="hover:text-white transition-colors">{t.footer.links.industries}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.24em] uppercase font-bold text-slate-500">
              {t.footer.sections.services}
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#services" className="hover:text-white transition-colors">ERP / Odoo</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">RFID</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">Custom Dev</a></li>
              <li><a href="#services" className="hover:text-white transition-colors">AI · RPA</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[11px] tracking-[0.24em] uppercase font-bold text-slate-500">
              {t.footer.sections.contact}
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="h-3.5 w-3.5 mt-1 text-[#7BA7FF]" />
                <a href="mailto:info@jaytech.id" className="hover:text-white transition-colors">info@jaytech.id</a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="h-3.5 w-3.5 mt-1 text-[#7BA7FF]" />
                <a href="tel:+62817872707" className="hover:text-white transition-colors">+62 817 872 707</a>
              </li>
              <li className="flex items-start gap-2">
                <Globe className="h-3.5 w-3.5 mt-1 text-[#7BA7FF]" />
                <a href="https://jaytech.id" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">jaytech.id</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-slate-500">
          <div data-testid="footer-copy">{t.footer.copy.replace("{year}", year)}</div>
          <div className="tracking-[0.24em] uppercase">
            Digital Operational Transformation
          </div>
        </div>
      </div>
    </footer>
  );
}
